import React, { Fragment, useState, useEffect } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import * as constants from '../../../utils/Constants'

const borderColor = '#3778C2'
const styles = StyleSheet.create({
    header: {
        flexDirection: 'row',
        backgroundColor: '#3778C2',
        width: '100%',
        borderColor: 'black',
        border: '1px',
        height: '25px',
    },
    sno: {
        width: '10%',
        textAlign: 'left',
        color: '#fff',
        borderColor: 'black',
        paddingLeft: 8,
        borderColor: 'black',
        border: '1px',
        paddingTop: '5px'
    },
    snoVal: {
        width: '10%',
        textAlign: 'center',
        alignItems: 'center',
        paddingTop: '5px',
        borderColor: 'black',
        paddingLeft: 8,
        borderColor: 'black',
        border: '1px',
        height: 70
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        borderColor: 'black',
        border: '1px',
        height: 70,
        fontStyle: 'bold',
    },
    description: {
        width: '60%',
        color: '#fff',
        flexDirection: 'column',
        textAlign: 'left',
        borderColor: 'black',
        border: '1px',
        paddingLeft: 8,
        paddingTop: '5px'
    },
    descriptionVal: {
        width: '60%',
        flexDirection: 'column',
        textAlign: 'left',
        borderColor: 'black',
        border: '1px',
        paddingLeft: 8,
        paddingTop: '5px',
        height: 70
    },
    sac: {
        width: '40%',
        borderColor: 'black',
        color: '#fff',
        textAlign: 'center',
        paddingRight: 8,
        borderColor: 'black',
        border: '1px',
        paddingTop: '5px'
    },
    sacVal: {
        width: '40%',
        borderColor: 'black',
        textAlign: 'center',
        paddingTop: '5px',
        paddingRight: 8,
        borderColor: 'black',
        border: '1px',
        paddingTop: '5px',
        height: 70
    },
    amount: {
        width: '30%',
        textAlign: 'center',
        color: '#fff',
        paddingRight: 8,
        borderColor: 'black',
        border: '1px',
        paddingTop: '5px'
    },
    amountVal: {
        width: '30%',
        textAlign: 'center',
        paddingRight: 8,
        paddingTop: '5px',
        borderColor: 'black',
        border: '1px',
        paddingTop: '5px',
        height: 70
    },
    invoiceContainer: {
        width: '100%',
        justifyContent: 'flex-start',
        flexDirection: 'row',
        borderColor: 'black',
        color: 'black',
        marginTop: '10px',
        border: 1,
        height: 110,
        textAlign: 'Left',
        fontStyle: 'bold',
        marginBottom: '10px'
    },
    invoice: {
        width: '50%',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        borderColor: 'black',
        color: 'black',
        border: 1,
        textAlign: 'Left',
        fontStyle: 'bold',
    },
    invoiceHeader: {
        backgroundColor: '#3778C2',
        textAlign: 'center',
        height: 20,
        color: '#fff',
        alignItems: 'center',
        marginBottom: 10,
        paddingTop: 2
    },
    item: {
        textAlign: 'left',
        paddingLeft: 8,
    },
    detailsHeader: {
        width: '100%',
        flexGrow: 1,
        textAlign: 'center',
    },
    totalDescription: {
        width: '75%',
        textAlign: 'right',
        alignItems: 'center',
        alignContent: 'center',
        borderRightColor: 'black',
        borderRightWidth: 1,
        paddingRight: 8,
        height: 20
    },
    total: {
        width: '25%',
        textAlign: 'center',
        alignItems: 'center',
        alignContent: 'center',
        paddingRight: 8,
        height: 20
    },
    totalRow: {
        flexDirection: 'row',
        alignItems: 'center',
        height: 24,
        fontSize: 12,
        fontStyle: 'bold',
        alignContent: 'center',
        borderColor: 'black',
        borderWidth: 1,
    },
});

const InvoiceTableRow = ({ items }) => {


    const [candidateName, setCandidateName] = useState('')
    const loggedInUser = JSON.parse(localStorage.getItem('user'))
    
    useEffect(() => {
        var url = `${constants.GetCandidateByIdUrl}/${items.applyJobId}`
        fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            }
        })
            .then(res => res.json())
            .then(response => {
                setCandidateName(response.candidateName)
            })
    }, [])
    const numToWord = (num) => {
        var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
        var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        if ((num = num.toString()).length > 9) return 'overflow';
        var n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!n) return; var str = '';
        str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
        str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
        str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
        str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
        str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
        return str;
    }

    const subTotal = parseFloat(items.jobValue * (items.agentRegistration.percentageOfAgent / 100))
    const total = parseFloat(subTotal) + (((parseFloat(subTotal) * (9 / 100))) * 2)

    return (
        <Fragment>
            <View style={styles.header}>
                <Text style={styles.sno}>S No</Text>
                <Text style={styles.description}>Service Description</Text>
                <Text style={styles.sac}>SAC</Text>
                <Text style={styles.amount}>Amount</Text>
            </View>
            <View style={styles.row}>
                <Text style={styles.snoVal}>1</Text>
                <View style={styles.descriptionVal}>
                    <Text >Recruitment Fees</Text>
                    <Text >Employee Name: {candidateName}</Text>
                    <Text >Refer Annexure</Text>
                </View>
                <Text style={styles.sacVal}>998512</Text>
                <Text style={styles.amountVal}>Rs. {subTotal}</Text>
            </View>
            <View style={styles.invoiceContainer}>
                <View style={styles.invoice}>
                    <View style={styles.invoiceHeader}>
                        <Text style={styles.detailsHeader}>Amount In Words</Text>
                    </View>
                    <Text style={styles.item}>{numToWord(subTotal)} rupees only</Text>
                </View>
                {items.agentRegistration.gst &&
                    <View style={styles.invoice}>
                        <View style={styles.invoiceHeader}>
                            <Text style={styles.detailsHeader}>Gst Details</Text>
                        </View>
                        <Text style={styles.item}>Total Amount Before Tax: Rs. {subTotal.toFixed(2)}</Text>
                        {items.stateName !== 'Gujarat'
                            ? <Text style={styles.item}>Add IGST - 18 % : Rs. {parseFloat(subTotal) * (18 / 100)}</Text>
                            : <><Text style={styles.item}>Add CGST - 9% : Rs. {parseFloat(subTotal) * (9 / 100)}</Text>
                                <Text style={styles.item}>Add SGST - 9% : Rs. {parseFloat(subTotal) * (9 / 100)}</Text></>
                        }
                    </View>
                }
            </View>
            <View style={styles.totalRow}>
                <Text style={styles.totalDescription}>Grand Total</Text>
                <Text style={styles.total}>{!items.agentRegistration.gst ? `Rs. ${subTotal}` :
                    `Rs. ${Number.parseFloat(total).toFixed(2)}`}</Text>
            </View>
        </Fragment>
    )
};

export default InvoiceTableRow;